// extracted by mini-css-extract-plugin
export var actionButton = "_m8-0";
export var actionMenuContainer = "_m8-i";
export var bubble = "_m8-2";
export var bubbleActionMenu = "_m8-j";
export var bubbleContext = "_m8-6";
export var bubbleItems = "_m8-7";
export var customer = "_m8-3";
export var divider = "_m8-8";
export var fileList = "_m8-9";
export var hiddenComment = "_m8-o";
export var infoAbove = "_m8-a";
export var internal = "_m8-4";
export var lightActionButton = "_m8-1";
export var link = "_m8-b";
export var merchant = "_m8-5";
export var message = "_m8-c";
export var profilePicture = "_m8-e";
export var quillToolbarContainer = "_m8-f";
export var senderDate = "_m8-g";
export var senderDateCustomer = "_m8-h";
export var senderName = "_m8-d";
export var time = "_m8-k";
export var uploadedImage = "_m8-l";
export var username = "_m8-m";
export var xsmall = "_m8-n";